// extracted by mini-css-extract-plugin
module.exports = {"bcww6zb":"bcww6zb","d16kq653":"d16kq653"};